module.exports = __webpack_public_path__ + "static/media/conc.2c1a0ca2.png";